import { render } from "./Logos.vue?vue&type=template&id=9649aa7e&ts=true"
import script from "./Logos.vue?vue&type=script&lang=ts"
export * from "./Logos.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__